(function() {
  var drawer = document.querySelector('[data-cart-drawer]');
  if (!drawer) return;

  var i18nEl = drawer.querySelector('[data-cart-drawer-i18n]');
  var i18n = {};
  if (i18nEl && i18nEl.textContent) {
    try {
      i18n = JSON.parse(i18nEl.textContent);
    } catch (e) {
      i18n = {};
    }
  }

  var panel = drawer.querySelector('[data-cart-drawer-panel]');
  var content = drawer.querySelector('[data-cart-drawer-content]');
  var sectionId = 'cart-drawer';
  var lastFocus = null;
  var qtyBusy = false;
  var addBusy = false;

  function updateCartBadges(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function(el) {
      el.textContent = count;
      if (count > 0) {
        el.hidden = false;
        el.removeAttribute('hidden');
      } else {
        el.hidden = true;
        el.setAttribute('hidden', '');
      }
    });
  }

  function openDrawer() {
    lastFocus = document.activeElement;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('tambur-cart-drawer-open');
    if (panel) panel.focus();
  }

  function closeDrawer() {
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('tambur-cart-drawer-open');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  var closeSpinning = false;

  function closeDrawerWithSpin(btn) {
    if (!btn || closeSpinning || !drawer.classList.contains('is-open')) {
      closeDrawer();
      return;
    }
    try {
      if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        closeDrawer();
        return;
      }
    } catch (e) { /* ignore */ }

    closeSpinning = true;
    btn.classList.remove('is-spinning');
    void btn.offsetWidth;
    btn.classList.add('is-spinning');

    var finished = false;
    function finish() {
      if (finished) return;
      finished = true;
      btn.classList.remove('is-spinning');
      closeSpinning = false;
      closeDrawer();
    }

    var icon = btn.querySelector('.tambur-cart-drawer__close-icon') || btn.querySelector('svg');
    var target = icon || btn;
    var onEnd = function (ev) {
      if (ev && ev.target !== target && ev.target !== btn) return;
      target.removeEventListener('animationend', onEnd);
      finish();
    };
    target.addEventListener('animationend', onEnd);
    setTimeout(finish, 420);
  }

  function formatMoney(cents) {
    if (window.TamburFormatMoney) return window.TamburFormatMoney(cents);
    var n = (cents || 0) / 100;
    var iso = (window.TamburCurrency && window.TamburCurrency.iso) || 'SEK';
    return (n % 1 === 0 ? n.toString() : n.toFixed(2).replace('.', ',')) + ' ' + iso;
  }

  // Speglar snippeten tambur-cart-line-price: Shopifys automatiska rabatt ligger
  // inte i final_price, utan i discount_allocations.
  function lineDiscount(item, perUnit) {
    var total = (item.discount_allocations || []).reduce(function(sum, d) {
      return sum + (d.amount || 0);
    }, 0);
    if (perUnit && item.quantity > 1) return Math.floor(total / item.quantity);
    return total;
  }

  function priceRow(kind, label, gross, discount) {
    var net = (gross || 0) - discount;
    var value = discount > 0 && net > 0
      ? '<span class="tambur-cart-price__now">' + formatMoney(net) + '</span>' +
        '<span class="tambur-cart-price__was">' + formatMoney(gross) + '</span>'
      : formatMoney(gross);
    return '<div class="tambur-cart-drawer__item-' + kind + '">' +
      '<span class="tambur-cart-drawer__price-label">' + label + '</span>' +
      '<span class="tambur-cart-drawer__price-value">' + value + '</span>' +
      '</div>';
  }

  function renderDrawerFromCart(cart) {
    if (!content || !cart) return;
    var body = content.querySelector('[data-cart-drawer-body]');
    var footer = content.querySelector('[data-cart-drawer-footer]');
    if (!body) return;

    if (!cart.item_count) {
      body.innerHTML = '<p class="tambur-cart-drawer__empty">' + (i18n.empty || 'Your cart is empty.') + '</p>';
      if (footer) footer.hidden = true;
      return;
    }

    var html = '<ul class="tambur-cart-drawer__list" role="list">';
    cart.items.forEach(function(item, index) {
      var line = index + 1;
      var img = item.image
        ? '<img src="' + item.image + '" alt="' + (item.title || '').replace(/"/g, '&quot;') + '" loading="lazy">'
        : '';
      var vendor = item.vendor
        ? '<p class="tambur-cart-drawer__item-vendor">' + item.vendor + '</p>'
        : '';
      var variant =
        item.variant_title && item.variant_title !== 'Default Title'
          ? '<span class="tambur-cart-drawer__variant">' + item.variant_title + '</span>'
          : '';
      html +=
        '<li class="tambur-cart-drawer__item" data-cart-line="' + line + '" data-cart-line-key="' + item.key + '">' +
        '<a href="' + item.url + '" class="tambur-cart-drawer__item-image">' + img + '</a>' +
        '<div class="tambur-cart-drawer__item-info">' +
        vendor +
        '<a href="' + item.url + '" class="tambur-cart-drawer__item-title">' + (item.product_title || item.title) + '</a>' +
        variant +
        '<div class="tambur-cart-drawer__item-controls">' +
        '<div class="tambur-cart-drawer__qty" data-cart-qty-wrap>' +
        '<button type="button" class="tambur-cart-drawer__qty-btn" data-cart-qty-change="-1" aria-label="' + (i18n.decreaseQty || 'Decrease quantity').replace(/"/g, '&quot;') + '">−</button>' +
        '<span class="tambur-cart-drawer__qty-value" data-cart-qty>' + item.quantity + '</span>' +
        '<button type="button" class="tambur-cart-drawer__qty-btn" data-cart-qty-change="1" aria-label="' + (i18n.increaseQty || 'Increase quantity').replace(/"/g, '&quot;') + '">+</button>' +
        '</div>' +
        '</div>' +
        priceRow('unit', i18n.unitPrice || 'Unit price', item.original_price, lineDiscount(item, true)) +
        priceRow('total', i18n.total || 'Total', item.original_line_price, lineDiscount(item, false)) +
        '<button type="button" class="tambur-cart-drawer__remove" data-cart-remove>' + (i18n.remove || 'Remove') + '</button>' +
        '</div></li>';
    });
    html += '</ul>';
    body.innerHTML = html;

    if (footer) {
      footer.hidden = false;
      footer.removeAttribute('hidden');
      var sub = footer.querySelector('[data-cart-subtotal]');
      if (sub) sub.textContent = formatMoney(cart.total_price);
    }
  }

  function applySectionHtml(html) {
    if (!html || html.indexOf('tambur-cart-drawer__') === -1) {
      throw new Error('Ogiltigt svar från varukorgen');
    }
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var section = doc.getElementById('shopify-section-' + sectionId)
      || doc.querySelector('.shopify-section')
      || doc.body;
    content.innerHTML = section.innerHTML;
  }

  function buildSectionUrl(path) {
    var url = new URL(path || '/', window.location.origin);
    url.searchParams.set('section_id', sectionId);
    return url.toString();
  }

  function getSectionFetchUrls() {
    var urls = [];
    var seen = {};
    function addPath(path) {
      if (!path) return;
      var key = path.split('?')[0];
      if (seen[key]) return;
      seen[key] = true;
      urls.push(buildSectionUrl(key));
    }

    addPath(window.location.pathname || '/');
    var cartUrl = drawer.getAttribute('data-cart-url');
    if (cartUrl) {
      try {
        addPath(new URL(cartUrl, window.location.origin).pathname);
      } catch (e) {
        addPath(cartUrl);
      }
    } else {
      addPath('/cart');
    }
    return urls;
  }

  function fetchSectionHtml() {
    var urls = getSectionFetchUrls();
    var chain = Promise.reject();
    urls.forEach(function(url) {
      chain = chain.catch(function() {
        return fetch(url, { credentials: 'same-origin' }).then(function(res) {
          if (!res.ok) throw new Error('section fetch failed');
          return res.text();
        });
      });
    });
    return chain;
  }

  function refreshDrawer() {
    if (!content) return Promise.resolve();
    content.classList.add('is-loading');
    return fetchSectionHtml()
      .then(applySectionHtml)
      .finally(function() {
        content.classList.remove('is-loading');
      });
  }

  function fetchCart() {
    return fetch('/cart.js', { credentials: 'same-origin' }).then(function(r) { return r.json(); });
  }

  function changeLine(line, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    }).then(function(res) {
      return res.json().then(function(data) {
        if (!res.ok) throw data;
        return data;
      });
    });
  }

  function handleRemoveClick(btn) {
    if (qtyBusy) return;
    var item = btn.closest('[data-cart-line]');
    if (!item) return;

    var line = parseInt(item.getAttribute('data-cart-line'), 10);
    qtyBusy = true;
    btn.disabled = true;

    changeLine(line, 0)
      .then(function(cart) {
        updateCartBadges(cart.item_count);
        return refreshDrawer();
      })
      .catch(function(err) {
        var msg = (err && (err.description || err.message)) || i18n.removeError || 'Could not remove the item.';
        alert(msg);
      })
      .finally(function() {
        qtyBusy = false;
        btn.disabled = false;
      });
  }

  function handleQtyClick(btn) {
    if (qtyBusy) return;
    var item = btn.closest('[data-cart-line]');
    if (!item) return;

    var line = parseInt(item.getAttribute('data-cart-line'), 10);
    var qtyEl = item.querySelector('[data-cart-qty]');
    var current = parseInt(qtyEl && qtyEl.textContent, 10) || 0;
    var delta = parseInt(btn.getAttribute('data-cart-qty-change'), 10) || 0;
    var next = current + delta;
    if (next < 0) next = 0;

    qtyBusy = true;
    btn.disabled = true;

    changeLine(line, next)
      .then(function(cart) {
        updateCartBadges(cart.item_count);
        return refreshDrawer();
      })
      .catch(function(err) {
        var msg = (err && (err.description || err.message)) || i18n.qtyError || 'Could not update quantity.';
        alert(msg);
      })
      .finally(function() {
        qtyBusy = false;
        btn.disabled = false;
      });
  }

  if (content) {
    content.addEventListener('click', function(e) {
      var removeBtn = e.target.closest('[data-cart-remove]');
      if (removeBtn) {
        e.preventDefault();
        e.stopPropagation();
        handleRemoveClick(removeBtn);
        return;
      }

      var btn = e.target.closest('[data-cart-qty-change]');
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();
      handleQtyClick(btn);
    });
  }

  function isCartAddForm(form) {
    if (!form || form.tagName !== 'FORM') return false;
    if (form.getAttribute('data-ajax-cart') === 'false') return false;
    if (form.getAttribute('data-ajax-cart') === 'true') return true;
    var action = (form.getAttribute('action') || '').toLowerCase();
    return action.indexOf('/cart/add') !== -1;
  }

  function getFormVariantId(form) {
    var idInput = form.querySelector('input[name="id"]');
    if (!idInput) return null;
    var id = parseInt(idInput.value, 10);
    return id || null;
  }

  function getFormQuantity(form) {
    var q = form.querySelector('input[name="quantity"]');
    if (!q) return 1;
    var n = parseInt(q.value, 10);
    return n > 0 ? n : 1;
  }

  /* Tillbehör (t.ex. fat till kopp): [data-cart-addon-id] läggs till i samma anrop och antal.
     data-cart-addon-per: ett tillbehör räcker till så många varor (adaptern till 1-3 eller 1-7 stjärnor). */
  function getFormAddons(form) {
    var addons = [];
    form.querySelectorAll('input[data-cart-addon-id]').forEach(function(input) {
      if (input.disabled) return;
      var addonId = parseInt(input.value, 10);
      if (addonId) addons.push({ id: addonId, per: parseInt(input.getAttribute('data-cart-addon-per'), 10) || 1 });
    });
    return addons;
  }

  function addToCartFromForm(form) {
    var id = getFormVariantId(form);
    if (!id) return Promise.reject({ description: i18n.noVariant || 'No variant selected.' });
    var quantity = getFormQuantity(form);
    var addons = getFormAddons(form);
    var payload = { id: id, quantity: quantity };
    if (addons.length) {
      payload = {
        items: [{ id: id, quantity: quantity }].concat(addons.map(function(addon) {
          return { id: addon.id, quantity: Math.ceil(quantity / addon.per) };
        }))
      };
    }
    return fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload)
    }).then(function(res) {
      return res.json().then(function(data) {
        if (!res.ok) throw data;
        return data;
      });
    });
  }

  function syncCartUi() {
    return fetchCart()
      .then(function(cart) {
        updateCartBadges(cart.item_count);
        return refreshDrawer()
          .catch(function() {
            renderDrawerFromCart(cart);
          });
      });
  }

  function atcFeedback() {
    return window.TamburAtcFeedback || null;
  }

  function handleAddToCart(form, submitBtn) {
    if (addBusy) return Promise.resolve();
    addBusy = true;
    if (submitBtn) {
      submitBtn.disabled = true;
      var fb = atcFeedback();
      if (fb) fb.press(submitBtn);
    }

    return addToCartFromForm(form)
      .then(function(data) {
        (data && Array.isArray(data.items) ? data.items : [data]).forEach(function(item) {
          document.dispatchEvent(new CustomEvent('tambur:tracking:add-to-cart', { detail: item }));
        });
        var fbOk = atcFeedback();
        if (fbOk && submitBtn) {
          fbOk.success(submitBtn, {
            announce: submitBtn.getAttribute('data-atc-added-label') || i18n.added || 'Added to cart'
          });
        }
        /* Let the sunburst land on the button before the drawer slides in. */
        var drawerDelay = fbOk && submitBtn && fbOk.drawerDelayMs
          ? fbOk.drawerDelayMs()
          : 0;
        if (drawerDelay > 0) {
          setTimeout(openDrawer, drawerDelay);
        } else {
          openDrawer();
        }
        return syncCartUi();
      })
      .catch(function(err) {
        var fbFail = atcFeedback();
        if (fbFail && submitBtn) fbFail.fail(submitBtn);
        var msg = (err && err.description) ? err.description : (i18n.addError || 'Could not add to cart.');
        alert(msg);
      })
      .finally(function() {
        addBusy = false;
        if (submitBtn) submitBtn.disabled = false;
      });
  }

  document.addEventListener('click', function(e) {
    if (e.target.closest('[data-cart-drawer-open]')) {
      e.preventDefault();
      openDrawer();
      refreshDrawer().catch(function() { /* visa befintligt innehåll */ });
      return;
    }
    var closeBtn = e.target.closest('.tambur-cart-drawer__close[data-cart-drawer-close]');
    if (closeBtn) {
      e.preventDefault();
      closeDrawerWithSpin(closeBtn);
      return;
    }
    if (e.target.closest('[data-cart-drawer-close]')) {
      e.preventDefault();
      closeDrawer();
    }
  });

  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && drawer.classList.contains('is-open')) closeDrawer();
  });

  document.addEventListener('submit', function(e) {
    var form = e.target;
    if (!isCartAddForm(form)) return;

    var submitBtn = form.querySelector('[type="submit"]');
    if (submitBtn && submitBtn.disabled) return;

    e.preventDefault();
    e.stopPropagation();
    handleAddToCart(form, submitBtn);
  }, true);

  document.addEventListener('click', function(e) {
    var btn = e.target.closest('[data-add-to-cart]');
    if (!btn || btn.disabled || btn.hidden) return;
    var form = btn.closest('form');
    if (!form || !isCartAddForm(form)) return;
    e.preventDefault();
    e.stopPropagation();
    handleAddToCart(form, btn);
  }, true);

  fetchCart().then(function(cart) {
    updateCartBadges(cart.item_count);
    // Keep server-rendered drawer HTML (correct locale); cart.js titles are often Swedish.
  });
})();
